import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

const PayCost = () => {
    return (
        <Box>
            <Typography variant="h4">Pay Cost</Typography>
            <Typography variant="h6" sx={{my:3, textDecoration: 'underline'}}>Under Construction...<br/>Coming Soon...</Typography>
        </Box>
    );
};

export default PayCost;